module.exports = "pegasus_template/assets/blocks/column-6-theme3.png";